/* eslint-disable @next/next/no-img-element */
import React, { useState, useContext, useEffect, useRef } from "react";
import { Button } from "../../../shadcn/components/ui/button";
import RightArrowAccordian from "../../../icons/RightArrowAccordian";
import LeftArrowAccordian from "../../../icons/LeftArrowAccordian";
import { Context, getSearchResults, getWatermarkedImgixUrl } from "services";
import { DateTime } from "luxon";
import { useRouter } from "next/router";
interface UpcomingAuctionItems {
  title?: string;
  price?: string;
  address?: string;
  imageLink?: string;
  auctionDate?: string;
  bankName?: string;
  bankLogo?: React.ReactNode;
  propertyLink?: string;
  propertyDateType?: string;
  allPropertiesData?: any;
  sub_asset_type_name?: any;
  locality?: any;
}

const bankName = process.env.NEXT_PUBLIC_BANK;

export default function ComingSoonAuction(props: any) {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);
  const [upcomingAuction, setUpcomingAuction] = useState<
    UpcomingAuctionItems[]
  >([]);
  const [isPropertyFounded, setIsPropertyFounded] = useState<boolean>(false);
  const [arrowState, setArrowState] = useState({
    showRightArrow: true,
    showLeftArrow: false,
  });
  const init = async () => {
    const data: any = await getSearchResults({
      searches: [
        {
          collection: "properties",
          q: "*",
          query_by: "",
          // facet_by: "dump.location.locality_slug",
          // facet_return_parent: "dump.location.locality_slug",
          filter: "true",
          filter_by: `status:active && property_date_type:=undated && dump.asset.asset_type_slug:=${searchForm.value.asset_type.value} && dump.location.city_name:${searchForm.value.city.label} && dump.bank.bank_slug:${bankName}`,
          max_facet_values: "100",
          per_page: 4,
          sort_by: "auction_start_date_unix_timestamp:asc",
        },
        {
          collection: "properties",
          q: "*",
          query_by: "",
          // facet_by: "dump.location.locality_slug",
          // facet_return_parent: "dump.location.locality_slug",
          filter: "true",
          filter_by: `status:active && property_date_type:=undated && dump.location.city_name:${searchForm.value.city.label} && dump.bank.bank_slug:${bankName}`,
          max_facet_values: "100",
          per_page: 4,
          sort_by: "auction_start_date_unix_timestamp:asc",
        },
        {
          collection: "properties",
          q: "*",
          query_by: "",
          // facet_by: "dump.location.locality_slug",
          // facet_return_parent: "dump.location.locality_slug",
          filter: "true",
          filter_by: `status:active && property_date_type:=undated && dump.bank.bank_slug:${bankName}`,
          max_facet_values: "100",
          per_page: 4,
          sort_by: "auction_start_date_unix_timestamp:asc",
        },
      ],
    });

    const allUpcomingAuctionProperties =
      [
        ...(data.results[0]?.hits || []),
        ...(data.results[1]?.hits || []),
        ...(data.results[2]?.hits || []),
      ].map((hit: any) => ({
        title: hit.document.borrower_name ? hit.document.borrower_name : "",
        price: hit.document.reserve_price,
        address: hit.document?.address?.split(" ").slice(0, 10).join(" "),
        imageLink: hit.document?.dump?.property_image
          ? getWatermarkedImgixUrl(
              `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${hit.document?.dump?.property_image}`,
            )
          : hit.document?.dump?.asset?.placeholder_image
          ? getWatermarkedImgixUrl(
              `${process.env.NEXT_PUBLIC_IMAGIX_URL}/${hit?.document?.dump?.asset?.placeholder_image}`,
            )
          : "/ShortListedProperty.png",
        auctionDate: DateTime.fromISO(hit.document.auction_start_date_time)
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy"),
        bankName: hit?.document?.dump?.bank?.bank_name,
        bankLogo: (
          <p className="bg-brand-orange rounded-full flex justify-center items-center h-6 w-6 font-openSans font-semibold uppercase text-web-body-sm leading-4 text-white py-2">
            {hit?.document?.dump?.bank?.bank_name?.charAt(0)}
          </p>
        ),
        // <HDFCLogo height="22px" width="22px" />, // Assuming bankLogo is static
        propertyLink: `/auction-properties/${hit.document.listing_id}`,
        propertyDateType: hit.document.property_date_type,
        locality: `${hit.document.dump?.location?.city_name},${hit.document.dump?.location?.state_name}`,
        sub_asset_type_name: hit.document?.dump?.asset?.sub_asset_type_name,
        listing_id: hit.document?.listing_id,
      })) || [];

    const newUpcomingAuctionProperties = allUpcomingAuctionProperties.filter(
      (prop, index, self) =>
        prop.listing_id &&
        index === self.findIndex((p) => p.listing_id === prop.listing_id),
    );

    setUpcomingAuction(newUpcomingAuctionProperties);
    if (
      data?.results?.[0]?.hits?.length + data?.results?.[1]?.hits?.length >
      0
    ) {
      setIsPropertyFounded(true);
    } else {
      setIsPropertyFounded(false);
    }
  };
  useEffect(() => {
    init();
  }, [searchForm.value.city]);

  const auctionContainerRef = useRef<HTMLDivElement>(null);

  const scrollToEnd = (direction: "left" | "right") => {
    const container = auctionContainerRef.current;
    if (container) {
      container.scrollBy({
        left:
          direction === "right"
            ? container.offsetWidth
            : -container.offsetWidth,
        behavior: "smooth",
      });
    }
  };

  const handleScroll = () => {
    const container = auctionContainerRef.current;
    if (container) {
      const { scrollLeft, scrollWidth, offsetWidth } = container;
      setArrowState((prevState) => ({
        ...prevState,
        showRightArrow: scrollLeft + offsetWidth < scrollWidth - 10,
        showLeftArrow: scrollLeft > 0,
      }));
    }
  };

  return (
    <>
      {upcomingAuction && upcomingAuction?.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 relative p-8 bg-[#F8F8F8]">
          <div className="order-1 uppercase text-[28px] md:text-[32px]">
            Coming Soon Auction
          </div>
          <Button
            className="order-3 md:order-2 mt-6 md:mt-0 md:justify-self-end text-black bg-white border-[1px] hover:bg-white hover:shadow-md"
            onClick={() => {
              if (isPropertyFounded && searchForm.value?.city?.value) {
                router.push(
                  `/auction-properties-in-${searchForm.value.city.value}?filter_by=undated`,
                );
              } else {
                searchForm.setField("city", { label: "All Cities", value: "" });
                router.push(`/auction-properties?filter_by=undated`);
              }
            }}
          >
            View all
          </Button>
          <div
            className="order-2 md:order-3 md:col-span-2 flex gap-6 overflow-x-scroll scrollbar-hide mt-[40px]"
            ref={auctionContainerRef}
            onScroll={handleScroll}
          >
            {upcomingAuction.slice(0, 6).map((item, index) => (
              <ComingSoonAuctionCard
                price={item.price}
                subAssetType={item.sub_asset_type_name}
                imageLink={item?.imageLink}
                address={item.locality}
                propertyLink={item.propertyLink}
                styles={{
                  linkStyle: `bg-white py-4 px-2`,
                  subAssetStyle: "bg-[#F1EAFF]",
                  priceStyle: "lg:text-base",
                }}
                key={`upcoming_prop_${index}`}
              />
            ))}
            {arrowState.showRightArrow && (
              <div className="hidden lg:flex items-center lg:px-9 bg-[linear-gradient(274deg,#F6F6F6_-5.15%,rgba(246,246,246,0.60)_141.55%)] absolute bottom-16 md:bottom-8 right-0 h-[120px]">
                <Button
                  className="rounded-lg border-[1px] border-brand-textLightGrey bg-transparent hover:bg-white hover:shadow-md"
                  onClick={() => scrollToEnd("right")}
                >
                  <RightArrowAccordian className="w-3 h-[14px] lg:w-[21px] lg:h-[26px]" />
                </Button>
              </div>
            )}
            {arrowState.showLeftArrow && (
              <div className="hidden lg:flex items-center lg:px-9 bg-[linear-gradient(274deg,#F6F6F6_-5.15%,rgba(246,246,246,0.60)_141.55%)] absolute bottom-16 md:bottom-8 left-0 h-[120px]">
                <Button
                  className="rounded-lg border-[1px] border-brand-textLightGrey bg-transparent hover:bg-white hover:shadow-md"
                  onClick={() => scrollToEnd("left")}
                >
                  <LeftArrowAccordian className="w-3 h-[14px] lg:w-[21px] lg:h-[26px]" />
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

interface ComingSoonAuctionCardProps {
  propertyLink: string | undefined;
  imageLink: string | undefined;
  price: string | undefined;
  address: string;
  subAssetType: string;
  styles?: {
    linkStyle?: string;
    imageStyle?: string;
    image?: string;
    subAssetStyle?: string; // For the sub-asset container
    priceStyle?: string; // For the price text
    addressStyle?: string; // For the address text
  };
}

const ComingSoonAuctionCard: React.FC<ComingSoonAuctionCardProps> = ({
  propertyLink,
  imageLink,
  price,
  address,
  subAssetType,
  styles = {}, // Destructure with default empty object
}) => {
  return (
    <a
      className={`flex bg-brand-lightBlue items-center shadow-md max-h-[112px] hover:scale-[1.01] hover:shadow-300 hover:duration-300 hover:ease-out min-w-[343px] clip-path-bottomRightUpcomingAuctionCard ${styles?.linkStyle}`}
      href={propertyLink}
    >
      <div
        className={`relative clip-path-bottomRightPropertyImage ${styles?.imageStyle}`}
      >
        <img
          className={`h-[60px] w-[146px] lg:w-[161px] lg:h-[80px] object-cover ${styles?.image}`}
          src={imageLink}
          alt=""
        />
        <div
          className={`absolute top-0 h-[18px] w-[115px] mid:h-[23px] mid:w-[127px] clip-path-subAssetText ${styles.subAssetStyle}`}
        >
          <p className="font-openSans ml-4 lg:ml-8 font-semibold text-web-body-sm leading-[20px] text-brand-textBlack tracking-widest capitalize">
            {subAssetType}
          </p>
        </div>
      </div>

      <div className="px-5 mid:pb-3">
        <p
          className={`font-openSans font-semibold text-web-subheading md:text-[24px] leading-6 md:leading-8 text-brand-textBlack ${styles.priceStyle}`}
        >
          Contact us
        </p>
        <p
          className={` capitalize font-openSans mt-1 mid:mt-[6px] font-normal text-web-body-sm mid:text-web-body-md leading-6 text-brand-textGrey ${styles.addressStyle}`}
        >
          {address}
        </p>
      </div>
    </a>
  );
};
